import { connect } from "react-redux";
import { default as component } from "./SetProjectPackageType.jsx";

// local selectors
import {
  getCurrentProjectPackageType,
  getProjectID,
} from "../../../duck/selectors";
// local actions
import { setProjectPackageType } from "./duck/actions";

// global selectors
import { getActiveModal } from "../../../../common/UI/ActiveModal/duck/selectors";
// global actions
import { dismissModal } from "../../../../common/UI/ActiveModal/duck/actions";

const mapStateToProps = (state) => {
  return {
    activeModal: getActiveModal(state),
    projectID: getProjectID(state),
    currentPackageType: getCurrentProjectPackageType(state),
  };
};

const mapDispatchToProps = {
  setProjectPackageType,
  dismissModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(component);
